module.exports = __webpack_public_path__ + "static/img/HomeWork.e57fed48.png";